/*
 * Copyright (c) 2025. Dave van Rijn Development
 */

export interface SystemOptions {
    platformURL: string;
    sentryUrl: string | null;
    mode: 'prod' | 'test' | 'dev';
}

interface Settings extends Record<string, SystemOptions> {
    prod: SystemOptions;
    dev: SystemOptions;
}

const defaultSettings: SystemOptions = {
    mode: 'prod',
    platformURL: '',
    sentryUrl: null,
};

const appSettings: Settings = {
    prod: {
        ...defaultSettings,
        platformURL: 'https://wachtlijst.bowies.nl/bowies-waitlist-core',
    },
    dev: {
        ...defaultSettings,
        mode: 'dev',
        platformURL: 'http://127.0.0.1:8000',
    }
};

const mode = window.mode || 'prod';
window.settings = appSettings[mode];
